// External Packages
import { useContext, useState, Fragment, useEffect } from "react";

// Internal Packages
import { fetchVehicleLocations, fetchVehicleReport } from "../../api/fetch";
import { AuthContext } from "../../context/auth-context";

// External Components
import { MdRefresh } from "react-icons/md";
import { FiExternalLink } from "react-icons/fi";

// Internal Components
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";

export default function VehicleReport({ vehicle }) {
  const { user } = useContext(AuthContext);

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState(null);

  // =================== FETCH SAMSARA INFO ===================
  const fetchLocationsHandler = async () => {
    try {
      setWarning();
      setLoading(true);
      const response = await fetchVehicleLocations(user, {
        vins: [vehicle.vin],
      });
      setData(response[0]);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setWarning(err.message);
      setLoading(false);
    }
  };

  // =================== USE EFFECT ===================
  useEffect(() => {
    if (vehicle) fetchLocationsHandler();
  }, [vehicle]);

  return (
    <div className="grid gap-4 mb-4">
      <Heading
        title="Vehicle Status"
        text="Information below is collected from Linxup Tracker devices."
      >
        <MdRefresh onClick={fetchLocationsHandler} className="text-2xl icon" />
        <a
          href="https://app02.linxup.com/ng/portal/index.html"
          target="_blank"
          title="View on Linxup"
        >
          <FiExternalLink className="icon" />
        </a>
      </Heading>

      {loading ? (
        <LoadingSpinnerWrapper />
      ) : (
        <div className="info">
          <DetailPair label="Device Serial" value={data?.deviceSerialNumber} />
          <DetailPair label="Speed" value={`${data?.speed || "-"} mph`} />
          <DetailPair label="Status" value={data?.status} />
          <DetailPair label="Location" value={data?.address} />
          <DetailPair
            label="Mileage"
            value={`${
              data?.virtualOdo ? Number(data.virtualOdo).toFixed(0) : "-"
            } mi`}
          />
          <DetailPair label="Fuel" value={`${data?.fuelLevel || "-"}`} />
        </div>
      )}
      {warning && <p className="text-sm text-red-600">{warning}</p>}
    </div>
  );
}
